import { FEATURES } from "../config/features";

export const initialFormAccessRightsState = {
  Home: [
    { key: "hasHome", name: "Home", value: false },
  ],
  Personnel: [
    { key: "hasAddEmployee", name: "Add Employee", value: false },
    { key: "hasEmployeeList", name: "Employee List", value: false },
    { key: "hasEmployeeHeirarchy", name: "Employee Heirarchy", value: false },
    { key: "hasEmploymentStatus", name: "Employment Status", value: false },
    { key: "hasEmployeeSchedule", name: "Employee Schedule", value: false },
    { key: "hasEmployeereliever", name: "Employee Reliever", value: false },
    { key: "hasOnBoarding", name: "On boarding", value: false },
    { key: "hasOutBoarding", name: "Out boarding", value: false },
    { key: "hasOnBoardingPersonnel", name: "On boarding Personnel", value: false },
    { key: "hasEmployeeTransaction", name: "Employee Transaction", value: false },
    { key: "hasCrewList", name: "Crew List", value: false },
    { key: "hasEmployeeRequest", name: "Employee Request", value: false },
    { key: "hasEmployeeTypeTagging", name: "Employee Type Tagging", value: false },
    { key: "hasUploadingSchedule", name: "Uploading Schedule", value: false },
    { key: "hasMedicalClearance", name: "Medical Clearance", value: false },
  ],
  TalentManagement: [
    { key: "hasMRF", name: "MRF", value: false },
    { key: "hasTrainingAndSeminarProgram", name: "Training/Seminar Program", value: false },
    { key: "hasKpiPerformanceAppraisal", name: "Kpi Performance Appraisal", value: false },
  ],
  TimeKeeping: [
    { key: "hasTimeEntries", name: "Time Entries", value: false },
    { key: "hasTamperedApproval", name: "Tampered Approval", value: false },
    { key: "hasShiftSchedule", name: "Shift Schedule", value: false },
    { key: "hasUploadTimeEntriesFile", name: "Upload Time Entries File", value: false },
    { key: "hasUploadDaysEntries", name: "Upload Days Entries", value: false },
    { key: "hasUploadCvtLogs", name: "Upload CVT Logs", value: false },
    { key: "hasUploadTimeEntriesERE", name: "Upload Time Entries ERE", value: false },
  ],
  Payroll: [
    { key: "hasProcessPartialSalary", name: "Process Partial Salary", value: false },
    { key: "hasPartialSalary", name: "Partial Salary", value: false },
    { key: "hasProcessPayroll", name: "Process Payroll", value: false },
    { key: "has13thMonth", name: "13th Month", value: false },
    { key: "hasFinalPay", name: "Final Pay", value: false, isMaintenance: true },
    { key: "hasSubcon", name: "Subcon", value: false },
    { key: "hasAgency", name: "Agency", value: false },
    { key: "hasPayrollPeriod", name: "Payroll Period", value: false },
    { key: "hasPartialSalaryBatch", name: "Partial SalaryBatch", value: false },

  ],
  Maintenance: [
    { key: "hasHRCalendar", name: "HR Calendar", value: false },
    { key: "hasClient", name: "Client", value: false },
    { key: "hasPayType", name: "Pay Type", value: false },
    { key: "hasHoliday", name: "Holiday", value: false },
    { key: "hasHolidayType", name: "Holiday Type", value: false },
    { key: "hasLeaveType", name: "Leave Types", value: false },
    { key: "hasDepartment", name: "Department", value: false },
    { key: "hasSection", name: "Section", value: false },
    { key: "hasClassification", name: "Classification", value: false },
    { key: "hasCompany", name: "Company", value: false },
    { key: "hasPosition", name: "Position", value: false },
    { key: "hasEmployeeStatus", name: "Employee Status", value: false },
    { key: "hasJobTitle", name: "Job Title", value: false },
    { key: "hasEmployeeGroup1", name: "Employee Group 1", value: false },
    { key: "hasEmployeeGroup2", name: "Employee Group 2", value: false },
    { key: "hasLocation", name: "Location", value: false },
    { key: "hasTimeKeeper", name: "Time Keeper", value: false },
    { key: "hasPlantilya", name: "Plantilla", value: false },
    { key: "hasCostCenter", name: "Cost Center", value: false },
    { key: "hasPayrollJournalAccount", name: "Payroll Journal Account", value: false },
    { key: "hasOnBoardingRequirements", name: "Requirements", value: false },
    { key: "hasOutBoardingRequirements", name: "Out Boarding Requirements", value: false },
    { key: "hasVessel", name: "Vessel", value: false },
    { key: "hasVesselStatus", name: "Vessel Status", value: false },
    { key: "hasVesselFunction", name: "Vessel Function", value: false },
    { key: "hasKpiLegend", name: "Kpi Legend", value: false },
    { key: "hasDestination", name: "Destination", value: false },
    { key: "hasDivision", name: "Division", value: false },
    { key: "hasDistantWater", name: "Distant Water", value: false },
    { key: "hasAreaOfOperation", name: "Area Of Operation", value: false },
    { key: "hasSubArea", name: "Sub Area", value: false },
    { key: "hasVesselClass", name: "Vessel Class", value: false },
    { key: "hasOperationGroup", name: "Operation Group", value: false },
    { key: "hasVesselType", name: "Vessel Type", value: false },
    { key: "hasEmployeeType", name: "Employee Type", value: false },
    { key: "hasMemoType", name: "Memo Type", value: false },
    { key: "hasPartialSalarySchedule", name: "Partial Salary Schedule", value: false },
    { key: "hasClinicRequirements", name: "Clinic Requirements", value: false },
    { key: "hasSalaryAdvanceDeductionBracket", name: "Salary Advance Deduction Bracket", value: false },
    { key: "hasPayrollReasonCode", name: "Payroll Reason Code", value: false },
    { key: "hasMaintenanceSalaryCombinationCode", name: "Maintenance Salary Combination Code", value: false },
    { key: "hasLoansAccess", name: "Loans Access", value: false },
    { key: "hasMRFAccess", name: "MRF Access", value: false },
    { key: "hasEmployeeRequestAccess", name: "Employee Request Access", value: false },
    { key: "hasEmployeeTransactionAccess", name: "Employee Transaction Access", value: false },
    { key: "hasMedicalClearanceAccess", name: "Medical Clearance Access", value: false },
    { key: "hasSalaryAdvanceAccess", name: "Salary Advance Access", value: false },
    { key: "hasTransactionAccess", name: "Transaction Access", value: false },
  ],
  VesselModule: [
    { key: "hasVessel201", name: "Vessel 201", value: false },
  ],
  SalaryModule: [
    { key: "hasEmployeeMonthlySalary", name: "Employee Monthly Salary", value: false },
    { key: "hasEmployeeDailySalary", name: "Employee Daily Salary", value: false },
    // { key: "hasPositionDesignationSalary", name: "Position - Designation Salary", value: false },
    { key: "hasMaintenanceSalaryCombination", name: "Maintenance Salary Combination", value: false },
    { key: "hasQuotaBasedSalary", name: "Quota-Based Salary", value: false },
    { key: "hasEmployeeBankAccount", name: "Employee Bank Account", value: false },

  ],
  GovernmentPremiums: [
    { key: "hasBIRTax", name: "BIR / Tax", value: false },
    { key: "hasPagibig", name: "Pagibig", value: false },
    { key: "hasSSS", name: "SSS", value: false },
    { key: "hasPhilhealth", name: "Philhealth", value: false },
  ],

  Transactions: [
    { key: "hasDTR", name: "DTR (Admin's View)", value: false },
    { key: "hasDTRBiometrics", name: "DTR (Employee's View)", value: false },
    { key: "hasDTRWithOTViewing", name: "DTR With OT Viewing", value: false },
    { key: "hasMobileDTRApproval", name: "Mobile DTR Approval", value: false },
    { key: "hasApproverHierarchy", name: "Approver Hierarchy", value: false },
    ...(FEATURES.APPROVER_PER_LOCATION
      ? [{ key: "hasApproverheirarchyperlocation", name: "Approver Hierarchy Per Location", value: false }]
      : []),
    { key: "hasApproverMaintenance", name: "Approver Per Maintenance", value: false },
    { key: "hasRequestApproval", name: "Request Approval", value: false },
    { key: "hasRequestApprovalTimeKeeper", name: "Request Approval Time Keeper", value: false },
    { key: "hasMassapproval", name: "Mass Approval", value: false },
    { key: "hasDTRCorrectionWorkers", name: "DTR Correction Workers", value: false },
    { key: "hasLeaveEncashment", name: "Leave Encashment", value: false },
    { key: "hasLeaveIncentive", name: "Leave Incentive", value: false },
    { key: "hasOvertime", name: "Overtime", value: false },
    { key: "hasDTRCorrection", name: "DTR Correction", value: false },
    { key: "hasLeave", name: "Leave", value: false },
    { key: "hasChangeOfSchedule", name: "Change of Schedule", value: false },
    { key: "hasOffsetCredits", name: "Offset Credits", value: false },
    { key: "hasOffsetRequest", name: "Offset Request", value: false },
    { key: "hasSalaryAdvanceRequest", name: "Salary Advance Request", value: false },
  ],
  LoansAndBenefits: [
    { key: "hasLoanTransaction", name: "Loan Transaction", value: false },
    { key: "hasSSSLoan", name: "SSS Loan", value: false },
    { key: "hasSSSEmergencyLoan", name: "SSS EmergencyLoan", value: false },
    { key: "hasSSSCalamityLoan", name: "SSS Calamity Loan", value: false },
    { key: "hasPagibigLoan", name: "Pagibig Loan", value: false },
    { key: "hasPagibigCalamityLoan", name: "Pagibig Calamity Loan", value: false },
    ...(FEATURES.ALOW_CASH_ADVANCE_MODULE
      ? [{ key: "hasCashAdvance", name: "Cash Advance", value: false }]
      : []),
    // { key: "hasCashAdvance", name: "Cash Advance", value: false },
    ...(FEATURES.ALLOW_SALARY_ADVANCE_MODULE
      ? [{ key: "hasSalaryAdvance", name: "Salary Advance", value: false }]
      : []),
    // { key: "hasSalaryAdvance", name: "Salary Advance", value: false },
    { key: "hasLoans", name: "Loans", value: false },
    { key: "hasDeductions", name: "Deductions", value: false },
    { key: "hasBenefits", name: "Benefits", value: false },
  ],
  Reports: [
    { key: "hasBIR2316", name: "BIR Form No. 2316", value: false },
    { key: "hasBIR1601C", name: "BIR Form No. 1601C", value: false },
    { key: "hasAlphaList", name: "Alphalist", value: false },
    { key: "hasPerDayTracker", name: "Per Day Tracker", value: false },
    { key: "hasOvertimeSummaryReport", name: "Overtime Summary Report", value: false },
    { key: "hasTrackerReport", name: "Tracker Report", value: false },
    { key: "hasPayslip", name: "Payslip", value: false },
    { key: "hasPayrollRegister", name: "Payroll Register", value: false },
    { key: "hasResigned", name: "Resigned", value: false },
    { key: "hasActiveEmployees", name: "Active Employees", value: false },
    { key: "hasYearofService", name: "Year of Service", value: false },
    { key: "hasSSSSummary", name: "SSS Summary", value: false },
    { key: "hasPagibigSummary", name: "Pagibig Summary", value: false },
    { key: "hasPhilhealthSummary", name: "Philhealth Summary", value: false },
    { key: "hasSSSLoanReport", name: "SSS Loan Report", value: false },
    { key: "hasPagibigLoanReport", name: "Pagibig Loan Report", value: false },
    { key: "has201Report", name: "201 Report", value: false },
    { key: "hasAttendanceReport", name: "Attendance Report", value: false },
    { key: "hasBankTransmittalBDO", name: "Bank Transmittal BDO", value: false },
    { key: "hasBankTransmittalBPI", name: "Bank Transmittal BPI", value: false },
    { key: "hasBankTransmittalChinaBankSavings", name: "Bank Transmittal China Bank Savings", value: false },
    { key: "hasBankTransmittalHSBC", name: "Bank Transmittal HSBC", value: false },
    { key: "hasBankTransmittalSecurityBank", name: "Bank Transmittal Security Bank", value: false },
    { key: "hasSummaryOfTardiness", name: "Summary Of Tardiness", value: false },
    { key: "hasAbsencesMemo", name: "Absences Memo", value: false },
    { key: "hasAbsencesReport", name: "Absences Report", value: false },
    { key: "hasActionHistoryReport", name: "Action History Report", value: false },
    { key: "hasAllowanceSummary", name: "Allowance Summary", value: false },
    { key: "hasAuditTrailReportEmployeeSetup", name: "Audit Trail Report - Employee Setup", value: false },
    { key: "hasBundyClockUsage", name: "Bundy Clock Usage", value: false },
    { key: "hasBasicPayAdjustmentReport", name: "Basic Pay Adjustment Report", value: false },
    { key: "hasCertificateOfEmployment", name: "Certificate Of Employment", value: false },
    { key: "hasCertificateOfPagibig", name: "Certificate Of Pagibig", value: false },
    { key: "hasCertificateOfPhilhealth", name: "Certificate Of Philhealth", value: false },
    { key: "hasCertificateOfSSS", name: "Certificate Of SSS", value: false },
    { key: "hasCommissionsSummary", name: "Commissions Summary", value: false },
    { key: "hasCostCenterReport", name: "Cost Center Report", value: false },
    { key: "hasDeductionsPerMonth", name: "Deductions Per Month", value: false },
    { key: "hasDTRReport", name: "DTR Report", value: false },
    { key: "hasEarningsPerMonth", name: "Earnings Per Month", value: false },
    { key: "hasEmployeeLeaveGroup", name: "Employee Leave Group", value: false },
    { key: "hasEmployeeOvertimeGroup", name: "Employee Overtime Group", value: false },
    { key: "hasEmployeeExpenseGroup", name: "Employee Expense Group", value: false },
    { key: "hasEmployeeLeaveHistory", name: "Employee Leave History", value: false },
    { key: "hasEmployeeListingByHiringDate", name: "Employee Listing By Hiring Date", value: false },
    { key: "hasEmployeeRegister", name: "Employee Register", value: false },
    { key: "hasExpenseReport", name: "Expense Report", value: false },
    { key: "hasGovernmentEmployeeInventory", name: "Government Employee Inventory", value: false },
    { key: "hasHeadcountReport", name: "Headcount Report", value: false },
    { key: "hasHolidayPremiumSummary", name: "Holiday Premium Summary", value: false },
    { key: "hasLeaveLedgerReport", name: "Leave Ledger Report", value: false },
    { key: "hasLeaveSummaryReport", name: "Leave Summary Report", value: false },
    { key: "hasLoanHistory", name: "Loan History", value: false },
    { key: "hasLoanPaymentsSummary", name: "Loan Payments Summary", value: false },
    { key: "hasLoansMonthlyAmortizationSummary", name: "Loans Monthly Amortization Summary", value: false },
    { key: "hasLoansPenaltyHistory", name: "Loans Penalty History", value: false },
    { key: "hasNightDifferentialSummary", name: "Night Differential Summary", value: false },
    { key: "hasNonTaxableAllowancesReport", name: "Non Taxable Allowances Report", value: false },
    { key: "hasOtherEarningsReport", name: "Other Earnings Report", value: false },
    { key: "hasOtherDeductionsSummary", name: "Other Deductions Summary", value: false },
    { key: "hasOutstandingLoans", name: "Outstanding Loans", value: false },
    { key: "hasPayrollCashRegister", name: "Payroll Cash Register", value: false },
    { key: "hasPayrollCheckRegister", name: "Payroll Check Register", value: false },
    { key: "hasPayrollDebitMemo", name: "Payroll Debit Memo", value: false },
    { key: "hasPayrollJournalByCostCenter", name: "Payroll Journal By Cost Center", value: false },
    { key: "hasPayrollJournalByDepartment", name: "Payroll Journal By Department", value: false },
    { key: "hasPayrollJournalBySummary", name: "Payroll Journal By Summary", value: false },
    { key: "hasPayrollPerPaymentMethod", name: "Payroll Per Payment Method", value: false },
    { key: "hasSelectLogs", name: "Select Logs", value: false },
    { key: "hasSummaryReportByMonthAndDepartment", name: "Summary Report By Month And Department", value: false },
    { key: "hasTardinessMemo", name: "Tardiness Memo", value: false },
    { key: "hasTimeKeepingHistoryDetailedReport", name: "Time Keeping History Detailed Report", value: false },
    { key: "hasTimeKeepingHoursWorkedReport", name: "Time Keeping Hours Worked Report", value: false },
    { key: "hasTimeKeepingHoursWorkedSummary", name: "Time Keeping Hours Worked Summary", value: false },
    { key: "hasTimesheetStatusReport", name: "Timesheet Status Report", value: false },
    { key: "hasYTDDeductionSummary", name: "YTD Deduction Summary", value: false },
    { key: "hasYTDEarningsSummary", name: "YTD Earnings Summary", value: false },
    { key: "hasYTDPayrollRegister", name: "YTD Payroll Register", value: false },
    // { key: "hasManHour", name: "Man Hour", value: false },
    // { key: "hasYearlyReport", name: "Yearly Report", value: false },
    { key: "hasLoanReport", name: "Loan Report", value: false },
    { key: "hasBankTransmittalReport", name: "Bank Transmittal Report", value: false },
    { key: "hasBIR0619E", name: "BIR Form No. 0619E", value: false },
    { key: "hasBIR0619F", name: "BIR Form No. 0619F", value: false },
    { key: "hasReportR1A", name: "SSS Employment Report (R-1A)", value: false },
    { key: "hasReportR3", name: "SSS Contribution Collection List (R-3)", value: false },
    { key: "hasReportR5", name: "SSS Contribution Collection List Summary (R-5)", value: false },
    { key: "hasReportML1", name: "SSS Member Loan Collection List (ML-1)", value: false },
    { key: "hasEmployeeContributionHistory", name: "Employee Contribution History (Philhealth)", value: false },
    { key: "hasSalaryLoanDeductionReport", name: "Salary Loan Deduction Report", value: false },
    { key: "hasCalamityLoanDeductionSummary", name: "SSS Calamity Loan Report", value: false },
    { key: "hasReportMCRFModule", name: "Membership Contribution Remittance Form (MCRF)", value: false },
    { key: "hasReportSTL", name: "Short-Term Loan Remittance (STL)", value: false },
    { key: "hasReportHousingLoan", name: "Housing Loan Remittance Report", value: false },
    { key: "hasReportRF1", name: "Employer's Remittance Report (RF-1)", value: false },
    { key: "hasReportER2", name: "Report of Employee-Members (ER-2)", value: false },
    { key: "hasEmployeeContributionLedger", name: "Employee Contribution Ledger (Philhealth)", value: false },
    { key: "hasSeparatedEmployeeReport", name: "Separated Employee Report", value: false },
  ],
  Settings: [
    { key: "hasSettings", name: "Settings", value: false },
  ],
  Calendar: [
    { key: "hasCalendar", name: "Calendar", value: false },
  ],
  Users: [
    { key: "hasUser", name: "Users", value: false },
  ],
  Others: [
    { key: "hasNotification", name: "Notifications", value: false },
    { key: "hasMobileBiometrics", name: "Mobile Biometrics", value: false },
  ],
  DevMode: [
    { key: "hasDTRRulesConfiguration", name: "DTR Rules Configuration", value: false },
    { key: "hasOTFormulas", name: "OT Formulas", value: false },
    { key: "hasMonthlyWorkingDaysFormulas", name: "Monthly Working Days Formulas", value: false },
    { key: "hasNightDifferential", name: "Night Differential", value: false },
    { key: "hasGovPremiumFormulas", name: "Gov Premium Formulas", value: false },
    { key: "hasClientIdentity", name: "Client Identity", value: false },
    { key: "hasGracePeriod", name: "Grace Period", value: false },
    { key: "hasPayrollRateConfig", name: "Payroll Rate Config", value: false },
    { key: "hasExcelUploadHelper", name: "Excel Upload Helper", value: false },
    { key: "hasLeaveTypesDev", name: "Leave Types Dev", value: false },
    { key: "hasDevTest", name: "Dev Test", value: false },
    { key: "hasDevHobby", name: "Dev Hobby", value: false },

  ]
};

export const accessType = [
  { key: "createMode", name: "Create", value: false },
  { key: "editMode", name: "Change", value: false },
  { key: "deleteMode", name: "Delete", value: false },
  { key: "viewMode", name: "View", value: false },
]

// Transform each entry to include accessType
export const initialAccessRightsWithTypes = Object.entries(initialFormAccessRightsState).reduce(
  (acc, [category, items]) => {
    acc[category] = items.map(item => ({
      ...item,
      accessType: item.accessType ? [...item.accessType] : [...accessType] // clone array
    }));
    return acc;
  },
  {}
);